import { Directive, ElementRef, HostListener } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2';
@Directive({
  selector: '[emailValidator]'
})
export class EmailValidatorDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event.target.value']) onKeyup(value: string) {
    const isValid = this.validateAndStyle(value);
  }

  @HostListener('blur', ['$event.target.value']) onBlur(value: string) {
    const isValid = this.validateAndStyle(value);
    if(!isValid) {
      this.el.nativeElement.value = '';
      Swal.fire({ title: '¡Aviso!', text: 'Debe ingresar un Email valido', type: 'error' ,confirmButtonText: 'Entendido',})
    }
  }

  private validateAndStyle(value: string) {
    const isValidEmail =  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value);

    if (!isValidEmail) {
      this.el.nativeElement.style.border = '1px solid red';
    } else {
      this.el.nativeElement.style.border = '1px solid green';
    }
    return isValidEmail
  }
}
